export default "__VITE_ASSET__ea3035bb__"